import { WSTableCell } from "@wingspanhq/fe-component-library";
import { Currency } from "@wingspanhq/utils/dist/currency/currencies";
import { formatMoney } from "@wingspanhq/utils/dist/formatMoney";
import React from "react";

type Props = {
  amount: number;
  currency: Currency;
};

export const CashbackCell: React.FC<Props> = props => (
  <WSTableCell
    text={formatMoney(props.amount, props.currency, {
      showSign: true
    })}
    secondaryText={props.amount > 0 ? "Cashback earned" : "Cashback reversal"}
  />
);
